import React, { useState, useEffect } from "react";
import LkNav from "./LkMenu/LkNav";
import LkDelivery from "./LkDelivery/LkDelivery";
import LkLoyalty from "./LkLoyalty/LkLoyalty";
import LkFooter from "./LkFooter";
import LkMenuMobile from "./LkMenu/LkMenuMobile";
import LkMenuMobileNav from "./LkMenu/LkMenuMobileNav";
import Dostavka from './LkDostavka/Dostavka';
import Modal from "./Modals/Modal";

const Lk = (props) => {
    const [activeMenu, setActiveMenu] = useState(parseInt(localStorage.getItem("lkActiveMenu")) || 0);
    const [navOpen, setNavOpen] = useState(true);
    const [navMobOpen, setNavMobOpen] = useState(false);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);


    const ClickNavOpen = () => {
        setNavOpen(!navOpen);
    };

    useEffect(() => {
        if (props.orderList.length === 0) {
            setIsModalOpen(true);
            setIsPopoverOpen(true);
        }
    }, [setIsPopoverOpen])

    const closeModal = () => {
        setIsModalOpen(false);
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 1024) {
                setNavOpen(false);
            }
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const ClickNavMobOpen = () => {
        setNavMobOpen(!navMobOpen);
    };

    const handleMenuClick = (index) => {
        localStorage.setItem("lkActiveMenu", index.toString());
        setActiveMenu(index);
        setNavMobOpen(false);
    };



    // Роутинг типа
    const renderActiveComponent = () => {
        switch (activeMenu) {
            case 0:
                return null;
            case 1:
                return <LkLoyalty subsData={props.subsData} subsUrls={props.subsUrls} data={props.data} loalty={props.data.loalty} profile={props.profile} />;
            case 2:
                return <Dostavka data={props.data} orderList={props.orderList} navOpen={navOpen} isPopoverOpen={isPopoverOpen} setIsPopoverOpen={setIsPopoverOpen} />;
            case 3:
                return null;
            case 4:
                return null;
            case 5:
                return null;
            case 6:
                return <LkDelivery delivery={props.data.LkDelivery.delivery} orderList={props.orderList} data={props.data} />;
            case 7:
                return null;
        }
    };

    return (
        <div className="w-full h-screen overflow-hidden"
            style={{
                backgroundColor: '#EFF0F2',
                color: '#1F2225'
            }}>
            <div className="fixed md:hidden p-[20px] top-0 left-0 z-50 w-full"
                style={{
                    backgroundColor: '#EFF0F2'
                }}>
                <LkMenuMobile
                    data={props.data}
                    navMobOpen={navMobOpen}
                    ClickNavMobOpen={ClickNavMobOpen}
                />
            </div>

            <div
                className={`fixed top-0 left-0 z-40 w-full h-full transition-opacity duration-300 ${navMobOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
            >
                <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                    <div className="h-full w-full overflow-y-auto hide-scrollbar"
                        style={{
                            backgroundColor: '#EFF0F2'
                        }}>
                        <LkMenuMobileNav
                            data={props.data}
                            activeMenu={activeMenu}
                            setActiveMenu={handleMenuClick}
                            onClose={() => setNavMobOpen(false)}
                        />
                    </div>
                </div>
            </div>

            <div className={`transition duration-300 w-full h-full sm:mt-[60px] md:mt-0 mb:mt-0 md:flex justify-between md:overflow-y-hidden  hide-scrollbar`}>
                <div className={`${navOpen ? 'min-w-[300px]' : 'w-[112px]'} md:block hidden overflow-y-auto hide-scrollbar`}>
                    <LkNav
                        profile={props.profile}
                        isPopoverOpen={isPopoverOpen}
                        setIsPopoverOpen={setIsPopoverOpen}
                        navOpen={navOpen}
                        data={props.data}
                        ClickNavOpen={ClickNavOpen}
                        activeMenu={activeMenu}
                        setActiveMenu={handleMenuClick}
                    />
                </div>

                <div className="w-full h-full overflow-y-auto overflow-x-hidden hide-scrollbar">
                    {renderActiveComponent()}

                    <div className="mt-[80px] sm:mt-0 md:hidden flex justify-center mb-[60px]"
                        style={{
                            backgroundColor: '#EFF0F2'
                        }}>
                        <LkFooter data={props.data} />
                    </div>
                </div>

            </div>
            {isModalOpen && (
                <Modal
                    data={props.data}
                    onClose={closeModal}
                    navOpen={navOpen}
                    isModalOpen={isModalOpen}
                />

            )}
        </div>
    );
}

export default Lk;
